import '../utilities/globals/index.js';
export type { MockedProviderProps } from './react/MockedProvider.js';
export { MockedProvider } from './react/MockedProvider.js';
export * from './core/index.js';
